<template>
  <div>   
    <div v-for="service in getServices" v-bind:key="service.id" class="mt-2 pt-1 pb-1 d-flex">
      <div class="product-amount-selection text-dark b-inline-block ml-auto mr-auto">

        <button class="button-minus ml-1 pl-1 pr-2 pt-n1 pb-2 " v-on:click="minus(service)">-</button>
        <div class="text-center text-bold">
          {{getServiceAmountOfPerson(service) }}
        </div>
        <button class="button-plus mr-0 pl-1 pr-2 pb-2" v-on:click="plus(service)">+</button>      

        <div class="ml-0">
          {{ service.title }}         
        </div>
        <div v-else class="ml-auto mr-1 ">
          <!-- frei --> 
        </div>
      </div>
    </div>
    
    
    <div v-if="getTotalSum() > 0" >

     <!--  <h5 style="display: inline-block;" class="mt-2">
        {{this.getLanguageItem['ShopUi']['ServiceSelectionTotalsLabel']}}</h5>
      <div style="display: inline-block;float: right;">{{getTotalSum()}} EUR</div> -->

    </div>
    <div v-else>
     <!--  <p class="mt-2">Tischreservierungen sind bei uns gratis!</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopTicketPersonGroupPrices",
  props: ["getSelectedItemId"],
  methods: {
    plus: function(priceGroup) {
      if (!priceGroup.seat) {
        if (priceGroup.prices.length - 1 > priceGroup.index) {
          priceGroup.index++;
        }
      } else {
        if (
          priceGroup.prices.length - 1 > priceGroup.index &&
          this.countTotalAmountOfPersons() <=
          this.getSelectedItem.maximumPersons
        ) {
          priceGroup.index++;

          // check if its not more than max ...could be if not all values are allowed, ok for 2 or 4 persons ...but not 3
          if (
            this.countTotalAmountOfPersons() >
            this.getSelectedItem.maximumPersons
          ) {
            priceGroup.index--;
          }

          //this.getSelectedItem.count = this.countTotalAmountOfPersons();
        } else {
          // just ignore or write message
        }
      }

      this.$parent.$emit('amountOFPersonsUpdated');
    },
    minus: function(priceGroup) {
      if (!priceGroup.seat) { // do we need to count this group?
        if (priceGroup.index > 0) {
          priceGroup.index--;
        }
      } else {
        /* console.log(
          "l:" + priceGroup.prices.length - 1 + " i:" + priceGroup.index
        ); */
        if (priceGroup.index > 0) {
          priceGroup.index--;
          //this.getSelectedItem.count = this.countTotalAmountOfPersons();
        }
      }
      
      this.$parent.$emit('amountOFPersonsUpdated');
    },
    getTotalSum: function() {
      let Sum = 0;
      this.getSelectedItem.personGroups.forEach(element => {
        Sum += Number.parseFloat(element.prices[element.index].price);
      });
      return Sum.toFixed(2);
    },
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },
    getServicePrice: function(service) {
      /* console.log("getServicePrice: " + service.prices[service.index].price); */
      return service.prices[service.index].price;
    },
    getServiceAmountOfPerson(service) {
      /*       console.log(
        "getServiceAmountOfPerson: " +
          service.prices[service.index].numberOfPersons
      ); */
      return service.prices[service.index].numberOfPersons;
    },
    countTotalAmountOfPersons() {
      let Amount = 0;
      this.getSelectedItem.personGroups.forEach(element => {
        // ignore NOSEAT
        if (element.seat) {
          Amount += Number.parseFloat(
            element.prices[element.index].numberOfPersons
          );
        }
      });
      return Amount;
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getServices() {
      // we have to do different things per TYPE
      //console.log("Type personGroupPrices: " + this.getSelectedItem.personGroups.length);

      return this.getSelectedItem.personGroups;
    },
    getSelectedItem() {
      return this.getCachedItem();
    }
  },
  beforeMount() {
    // fix default values for inputs
    this.getSelectedItem.count = 1; // this.getSelectedItem.minimumPersons;

    this.getSelectedItem.personGroups.forEach(g => {
      // set count to the first numberOfPersons in prices[], this will be our min for each service, it could be 0 or 1 or 2 ...
      g.count = g.prices[0].numberOfPersons;
    });
    //console.log(this.getSelectedItem);
  }
};
</script>
